export default __webpack_public_path__ + "static/media/undraw_Done_re_oak4.eda6f37e.svg";